// extracted by mini-css-extract-plugin
export var downArrow = "_92-0";
export var infoTooltipIcon = "_92-3";
export var label = "_92-1";
export var optionCard = "_92-4";
export var upArrow = "_92-2";